export default "__VITE_ASSET__BN49AQil__"